/**
 * Checks if metadata contains rich tool call information that's worth displaying in the MetadataViewer.
 * Returns false for metadata that only contains simple message type flags.
 * 
 * @param metadata - The metadata object to check
 * @returns true if metadata contains rich tool call data, false otherwise
 */
export function hasRichMetadata(metadata: Record<string, any> | null | undefined): boolean {
  if (!metadata || typeof metadata !== 'object') {
    return false;
  }

  // Check for rich metadata fields that indicate actual tool call data
  const richFields = [
    'raw_messages',
    'usage',
    'model_name',
    'provider_name',
    'provider_response_id'
  ];

  return richFields.some(field => field in metadata);
}

